<template>

<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 245 505">
  <defs>

  </defs>
  <g id="Layer_0_Image" data-name="Layer 0 Image">
      <image id="Layer_0_Image-2" data-name="Layer 0 Image" class="cls-1" width="245" height="505"
             xlink:href="https://static.supsis.live/common/aydinli/assets/PierreCardinAlert.svg" />
  </g>
</svg>
</template>
<script>
export default {
    name: "PierreCardin",
};
</script>
<style>
      .cls-1 {
        isolation: isolate;
      }
    </style>



// WEBPACK FOOTER //
// src/components/V2/uspaV2/asset/PierreCardin.vue